import { ref, watchEffect } from 'vue'
import { useRefreshTokenMutation } from '@server/graphql/mutations/refreshTokenMutation'
import { IRefreshTokenInput, IRefreshTokenResponse, IFetchRefreshTokenReturn } from '@types'

/**
 * Função para executar a mutação de refresh token.
 * @param refreshTokenInput As variáveis necessárias para a mutação.
 * @returns Um objeto com referências reativas para os dados, estado de carregamento, erros e função de parada.
 */
const mutateRefreshToken = (refreshTokenInput: IRefreshTokenInput): IFetchRefreshTokenReturn => {
  const data = ref<IRefreshTokenResponse | null>(null)
  const loading = ref<boolean>(false)
  const error = ref<Error | null>(null)
  const { mutate, onDone, onError } = useRefreshTokenMutation()

  const execute = async () => {
    loading.value = true
    try {
      await mutate({ refreshToken: refreshTokenInput.refreshToken })
    } catch (err) {
      error.value = err as Error
    }
  }

  const stop = watchEffect(() => {
    onDone(({ data: mutationData }) => {
      data.value = mutationData?.refreshToken.payload
      loading.value = false
    })

    onError(mutationError => {
      error.value = mutationError as Error
      loading.value = false
    })
  })

  return { execute, data, loading, error, stop }
}

export default mutateRefreshToken
